/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { GawdsOnchain, GawdsOnchainInterface } from "../GawdsOnchain";

const _abi = [
  {
    inputs: [],
    name: "NotValidGawdId",
    type: "error",
  },
  {
    inputs: [],
    name: "ValueCannotBeZero",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "enum Accent",
        name: "id",
        type: "uint8",
      },
    ],
    name: "accentName",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "id",
        type: "uint16",
      },
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "string",
        name: "gawdHash",
        type: "string",
      },
      {
        internalType: "enum Power",
        name: "dominantPower",
        type: "uint8",
      },
    ],
    name: "addGawd",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint16",
            name: "id",
            type: "uint16",
          },
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "string",
            name: "hash",
            type: "string",
          },
          {
            internalType: "enum Power",
            name: "dominantPower",
            type: "uint8",
          },
        ],
        internalType: "struct GawdsOnchain.Gawd",
        name: "gawd",
        type: "tuple",
      },
    ],
    name: "addGawdStruct",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint16",
            name: "id",
            type: "uint16",
          },
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "string",
            name: "hash",
            type: "string",
          },
          {
            internalType: "enum Power",
            name: "dominantPower",
            type: "uint8",
          },
        ],
        internalType: "struct GawdsOnchain.Gawd",
        name: "gawdData",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "enum PartType",
            name: "kind",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "value",
            type: "uint8",
          },
          {
            internalType: "enum Power",
            name: "power",
            type: "uint8",
          },
          {
            internalType: "enum Set",
            name: "set",
            type: "uint8",
          },
        ],
        internalType: "struct GawdsOnchain.GawdPart[]",
        name: "parts",
        type: "tuple[]",
      },
    ],
    name: "addGawdStructWithPartStructs",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "gawdID",
        type: "uint16",
      },
      {
        internalType: "enum PartType",
        name: "kind",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "value",
        type: "uint8",
      },
      {
        internalType: "enum Power",
        name: "power",
        type: "uint8",
      },
      {
        internalType: "enum Set",
        name: "set",
        type: "uint8",
      },
    ],
    name: "addPart",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "gawdID",
        type: "uint16",
      },
      {
        components: [
          {
            internalType: "enum PartType",
            name: "kind",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "value",
            type: "uint8",
          },
          {
            internalType: "enum Power",
            name: "power",
            type: "uint8",
          },
          {
            internalType: "enum Set",
            name: "set",
            type: "uint8",
          },
        ],
        internalType: "struct GawdsOnchain.GawdPart",
        name: "part",
        type: "tuple",
      },
    ],
    name: "addPartStruct",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum Set",
        name: "",
        type: "uint8",
      },
    ],
    name: "allSets",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum Aura",
        name: "id",
        type: "uint8",
      },
    ],
    name: "auraName",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint16",
            name: "id",
            type: "uint16",
          },
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "string",
            name: "hash",
            type: "string",
          },
          {
            internalType: "enum Power",
            name: "dominantPower",
            type: "uint8",
          },
        ],
        internalType: "struct GawdsOnchain.Gawd[]",
        name: "gawdData",
        type: "tuple[]",
      },
    ],
    name: "bulkAddGawdStructs",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint16",
            name: "id",
            type: "uint16",
          },
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "string",
            name: "hash",
            type: "string",
          },
          {
            internalType: "enum Power",
            name: "dominantPower",
            type: "uint8",
          },
        ],
        internalType: "struct GawdsOnchain.Gawd[]",
        name: "gawdData",
        type: "tuple[]",
      },
      {
        components: [
          {
            internalType: "enum PartType",
            name: "kind",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "value",
            type: "uint8",
          },
          {
            internalType: "enum Power",
            name: "power",
            type: "uint8",
          },
          {
            internalType: "enum Set",
            name: "set",
            type: "uint8",
          },
        ],
        internalType: "struct GawdsOnchain.GawdPart[][]",
        name: "parts",
        type: "tuple[][]",
      },
    ],
    name: "bulkAddGawdStructsWithPartStructs",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "gawdID",
        type: "uint16",
      },
      {
        components: [
          {
            internalType: "enum PartType",
            name: "kind",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "value",
            type: "uint8",
          },
          {
            internalType: "enum Power",
            name: "power",
            type: "uint8",
          },
          {
            internalType: "enum Set",
            name: "set",
            type: "uint8",
          },
        ],
        internalType: "struct GawdsOnchain.GawdPart[]",
        name: "parts",
        type: "tuple[]",
      },
    ],
    name: "bulkAddPartStructs",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum Composition",
        name: "id",
        type: "uint8",
      },
    ],
    name: "compositionName",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum Conveyence",
        name: "id",
        type: "uint8",
      },
    ],
    name: "conveyenceName",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum Power",
        name: "id",
        type: "uint8",
      },
    ],
    name: "cultForPower",
    outputs: [
      {
        internalType: "enum Cult",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum Cult",
        name: "cult",
        type: "uint8",
      },
    ],
    name: "cultName",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    name: "gawdAccents",
    outputs: [
      {
        internalType: "enum Accent",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "gawdAuras",
    outputs: [
      {
        internalType: "enum Aura",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    name: "gawdCompositions",
    outputs: [
      {
        internalType: "enum Composition",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    name: "gawdConveyences",
    outputs: [
      {
        internalType: "enum Conveyence",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    name: "gawdIrises",
    outputs: [
      {
        internalType: "enum Iris",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    name: "gawdOculuses",
    outputs: [
      {
        internalType: "enum Oculus",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "gawdPowers",
    outputs: [
      {
        internalType: "enum Power",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    name: "gawdRealms",
    outputs: [
      {
        internalType: "enum Realm",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "gawdSets",
    outputs: [
      {
        internalType: "enum Set",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    name: "gawds",
    outputs: [
      {
        internalType: "uint16",
        name: "id",
        type: "uint16",
      },
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "string",
        name: "hash",
        type: "string",
      },
      {
        internalType: "enum Power",
        name: "dominantPower",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "gawdsCount",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "gawdId",
        type: "uint16",
      },
    ],
    name: "getCultId",
    outputs: [
      {
        internalType: "enum Cult",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "gawdId",
        type: "uint16",
      },
    ],
    name: "getCultName",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "id",
        type: "uint16",
      },
    ],
    name: "getDominantPower",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "id",
        type: "uint16",
      },
    ],
    name: "getDominantPowerId",
    outputs: [
      {
        internalType: "enum Power",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "id",
        type: "uint16",
      },
    ],
    name: "getGawdAccents",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "id",
        type: "uint16",
      },
    ],
    name: "getGawdAura1",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "id",
        type: "uint16",
      },
    ],
    name: "getGawdAura2",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "id",
        type: "uint16",
      },
    ],
    name: "getGawdAuras",
    outputs: [
      {
        internalType: "string[2]",
        name: "",
        type: "string[2]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "id",
        type: "uint16",
      },
    ],
    name: "getGawdComposition",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "id",
        type: "uint16",
      },
    ],
    name: "getGawdConveyence",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "id",
        type: "uint16",
      },
    ],
    name: "getGawdHash",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "id",
        type: "uint16",
      },
    ],
    name: "getGawdIris",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "id",
        type: "uint16",
      },
    ],
    name: "getGawdName",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "id",
        type: "uint16",
      },
    ],
    name: "getGawdOculus",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "id",
        type: "uint16",
      },
    ],
    name: "getGawdPowers",
    outputs: [
      {
        internalType: "enum Power[]",
        name: "",
        type: "uint8[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "id",
        type: "uint16",
      },
    ],
    name: "getGawdRealm",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "id",
        type: "uint16",
      },
    ],
    name: "getGawdSets",
    outputs: [
      {
        internalType: "enum Set[]",
        name: "",
        type: "uint8[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum Iris",
        name: "id",
        type: "uint8",
      },
    ],
    name: "irisName",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "id",
        type: "uint16",
      },
    ],
    name: "isGawd",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum Oculus",
        name: "id",
        type: "uint8",
      },
    ],
    name: "oculusName",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum PartType",
        name: "id",
        type: "uint8",
      },
    ],
    name: "partName",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum Power",
        name: "id",
        type: "uint8",
      },
    ],
    name: "powerName",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum Realm",
        name: "id",
        type: "uint8",
      },
    ],
    name: "realmName",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "id",
        type: "uint16",
      },
    ],
    name: "removeGawd",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum Set",
        name: "id",
        type: "uint8",
      },
    ],
    name: "setName",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type GawdsOnchainConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: GawdsOnchainConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class GawdsOnchain__factory extends ContractFactory {
  constructor(...args: GawdsOnchainConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "GawdsOnchain";
  }

  override deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<GawdsOnchain> {
    return super.deploy(overrides || {}) as Promise<GawdsOnchain>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): GawdsOnchain {
    return super.attach(address) as GawdsOnchain;
  }
  override connect(signer: Signer): GawdsOnchain__factory {
    return super.connect(signer) as GawdsOnchain__factory;
  }
  static readonly contractName: "GawdsOnchain";

  public readonly contractName: "GawdsOnchain";

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): GawdsOnchainInterface {
    return new utils.Interface(_abi) as GawdsOnchainInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): GawdsOnchain {
    return new Contract(address, _abi, signerOrProvider) as GawdsOnchain;
  }
}
